/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function SearchIncidentByIdReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeSearchIncidentByIdAction } action: action
 *     de l'application
 * @return { Reducer }
 */
export const SearchIncidentByIdReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeSearchIncidentByIdAction) => {
      switch (action.type) {
        case actions.SearchIncidentByIdActionTypes
            .SEARCHINCIDENTBYID_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.SearchIncidentByIdActionTypes.SEARCHINCIDENTBYID_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.SearchIncidentByIdActionTypes.SEARCHINCIDENTBYID_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/explorer/search/index.ts